// src/components/programs/HeaderSection.jsx
import React, { useRef } from "react";
import { motion } from "framer-motion";
import ProgramVideo from "../../assets/Programs/videos/program_video.mp4";

export default function HeaderSection() {
  const videoRef = useRef(null);

  const bulletPoints = [
    {
      title: "Endurance Development",
      desc: "Build structured stamina phases that elevate aerobic capacity and steady-state output.",
    },
    {
      title: "Strength Progression",
      desc: "Advance muscle structure, controlled power, and balanced aesthetic development.",
    },
    {
      title: "Sport Foundations",
      desc: "Sharpen movement quality, precision, and on-field efficiency for specific performance needs.",
    },
  ];

  return (
<section className="w-full bg-black/20 flex justify-center px-6 md:px-12 py-20">
  <div className="w-full max-w-[95%] mx-auto flex flex-col md:flex-row items-center gap-12">
    
    {/* LEFT TEXT */}
    <motion.div
      initial={{ opacity: 0, x: -40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7 }}
      className="w-full md:w-1/2 flex flex-col gap-6"
    >
      <h1 className="text-5xl md:text-6xl font-extrabold leading-snug">
        <span className="text-white">Forge-</span>{""}
        <span className="text-gray-300">Your-</span>{""}
        <span className="text-gray-400">Foundation</span>
      </h1>
      <p className="text-neonTurquoise text-xl md:text-2xl italic max-w-[90%]">
        Focused guidance, structured advancement, and refined training methods.
      </p>

      <div className="flex flex-col gap-6 mt-4">
        {bulletPoints.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className="flex items-start gap-4"
          >
            <span className="text-neonTurquoise text-2xl">•</span>
            <div>
              <h3 className="text-white text-xl font-semibold">{item.title}</h3>
              <p className="text-grayText text-lg leading-relaxed">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>

    {/* RIGHT VIDEO */}
    <motion.div
      initial={{ opacity: 0, x: 40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7 }}
      className="w-full md:w-1/2 flex justify-center md:justify-end"
    >
      <video
        ref={videoRef}
        src={ProgramVideo}
        controls
        controlsList="nodownload"
        className="rounded-2xl shadow-xl w-full max-w-[480px]"
        style={{ height: "400px", objectFit: "cover" }}
      />
    </motion.div>
    
  </div>
</section>

  );
}
